import { FC } from 'react'

import { IconRain } from '@pijma/icon-gallery/crypto'

export const IconNegative: FC = () => <IconRain height="61px" width="61px" />
